import { isDefined } from '@avantia/form-validation';
import { SvgIcon } from '@avantia/style-guide';
import { applyChanges } from '../../../reducers/reducerLibrary';
import { HpClientStandardButtonTextAndStyle } from '../../../types';
import { HpButtonTextModifierFunction, HpCommonButtonControlProps } from '../../../types/inputControlTypes';
import { StandardFormGroupWidget } from '../../widgets/standardFormGroupWidget';
import { BasicButtonControl } from '../common/basicButtonControl';

export function ButtonControl(props: HpCommonButtonControlProps): JSX.Element {
  const { data, formatType } = props;
  const { textAndStyle: textAndStyleData } = data;
  const textAndStyle = textAndStyleData[formatType] as HpClientStandardButtonTextAndStyle;
  return buttonControlCommon(props, { textAndStyle });
}

export function AddGroupButtonControl(props: HpCommonButtonControlProps): JSX.Element {
  const { data, formatType } = props;
  const { textAndStyle: textAndStyleData } = data;
  let textAndStyle = textAndStyleData[formatType] as HpClientStandardButtonTextAndStyle;
  const { buttonStyle, cssClass } = textAndStyle;
  const extra: Partial<HpClientStandardButtonTextAndStyle> = {};
  if (!isDefined(buttonStyle)) {
    extra.buttonStyle = 'outline-primary';
  }

  if (!isDefined(cssClass)) {
    extra.cssClass = 'hp-group-add-another';
  }

  textAndStyle = applyChanges(textAndStyle, extra);
  return buttonControlCommon(props, {
    textAndStyle,
    buttonTextModifier: (buttonText) => {
      return (
        <>
          <SvgIcon type={'plus' as any} size="tiny" />
          {buttonText}
        </>
      );
    }
  });
}

interface HpButtonControlCommonProps {
  buttonTextModifier?: HpButtonTextModifierFunction;
  textAndStyle: HpClientStandardButtonTextAndStyle;
}

function buttonControlCommon(
  { data, disabled, errors, formatType, id, name, onClick, question, viewport, buttonText }: HpCommonButtonControlProps,
  { textAndStyle, buttonTextModifier }: HpButtonControlCommonProps
): JSX.Element {
  const { dependentActions } = data;
  return (
    <StandardFormGroupWidget
      id={id}
      question={question}
      control={
        <BasicButtonControl
          buttonText={buttonText}
          buttonTextModifier={buttonTextModifier}
          dependentActions={dependentActions}
          disabled={disabled}
          errors={errors}
          formatType={formatType}
          id={id}
          name={name}
          onClick={onClick}
          question={question}
          textAndStyle={textAndStyle}
          viewport={viewport}
        />
      }
      controlType="button"
      textAndStyle={textAndStyle}
      dataType={null}
      error={errors[id]}
      questionText={undefined}
      answerSource="default"
      errorPosition="bottom"
      subtext={undefined}
    />
  );
}
